export default {"src":"/_next/static/media/AddCircle.8b3647ac.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};